// extracted by mini-css-extract-plugin
export var chatHtmlText = "_qk-2";
export var chatLink = "_qk-0";
export var chatText = "_qk-1";